import React, { useState, Fragment, useContext } from 'react';
import './Screens.scss';
import { AppContext } from "../../Context/AppContext";
// Material UI
import Box from "@mui/material/Box";
import Button from '@mui/material/Button';
import Typography from "@mui/material/Typography";
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import Select from '@mui/material/Select';
import Fade from '@mui/material/Fade';
import Alert from '@mui/material/Alert';
// Custom Plugins
import { customCloneDeep } from '../../Plugins/HelperFunctions';

const Screen8 = () => {
  const { screensData, setScreensData, setActiveScreen, setShowSnackbar, setSnackbarMessage, setActiveFocus } = useContext(AppContext);
  const [screen8, setScreen8] = useState(screensData.screen8);

  const handleChange = (e) => {
    let { name, value } = e.target;
    let errorName = `${name}Error`

    if (value === '' || value === undefined) {
      setScreen8({
        ...screen8,
        [name]: value,
        [errorName]: true
      });
    } else {
      setScreen8({
        ...screen8,
        [name]: value,
        [errorName]: false
      });
    }
  };

  // Form Validator
  const formValidator = () => {
    //  For Only This Screen
    if (screen8.catalyticConverter === '' || screen8.catalyticConverter === undefined) {
      setScreen8({
        ...screen8,
        catalyticConverterError: true,
      })
      return false;
    }

    return true
  }

  const handleNext = () => {
    if (formValidator()) {
      let clonedScreensData = customCloneDeep(screensData);
      clonedScreensData.screen8 = screen8;
      setScreensData(clonedScreensData);

      setActiveScreen((prevactiveScreen) => prevactiveScreen + 1);

    } else {
      setShowSnackbar(true);
      setSnackbarMessage('All required fields are not filled');
    }
  }

  const handlePrevious = () => {
    setActiveScreen((prevactiveScreen) => prevactiveScreen - 1);
  }


  return (
    <Fragment>
      <div className="screen screenHeight">
        <form>
          <Box className="screen__wrapper" >
            <Box>
              <Typography variant="subtitle1" component="p" sx={{ pb: 2 }} >
                Does the car have the original catalytic converter?
              </Typography>
              <FormControl fullWidth error={screen8.catalyticConverterError} >
                <InputLabel id="catalyticConverter-select-label">Catalytic Converter</InputLabel>
                <Select
                  labelId="catalyticConverter-select-label"
                  label="Catalytic Converter"
                  name="catalyticConverter"
                  value={screen8.catalyticConverter}
                  onFocus={() => setActiveFocus('catalyticConverter')}
                  onChange={handleChange}
                >
                  <MenuItem value={1}>Yes</MenuItem>
                  <MenuItem value={0}>No</MenuItem>
                  <MenuItem value='not_sure'>Not Sure</MenuItem>
                </Select>
                {screen8.catalyticConverterError && <FormHelperText>Required</FormHelperText>}
              </FormControl>
            </Box>

            <Fade in={screen8.catalyticConverter === 'not_sure'}>
              <Alert severity="info">We'll inspect the vehicle for its catalytic convertor at the time of pickup. A missing catalytic convertor could result in a reduced offer.</Alert>
            </Fade>
          </Box>
        </form>
      </div>

      <Box className="screenBtnContainer" sx={{ pt: 4 }}>
        <Button
          variant="outlined"
          color="primary"
          onClick={handlePrevious}
        >
          Previous
        </Button>

        <Button
          variant="contained"
          color="primary"
          onClick={handleNext}
        >
          Next
        </Button>
      </Box>
    </Fragment>
  );
};

export default Screen8;
